/**
 * The live reservation path.
 *
 * Two calls, in order, because they do different jobs and can fail
 * differently: the first competes for the tables, the second records who the
 * vendor is. Splitting them means a vendor whose details are rejected still
 * holds their tables while they fix a typo, rather than losing the race and
 * having to start again.
 */
import { getFunctions, httpsCallable } from 'firebase/functions';
import type { PaymentMethod, Vendor } from '@lmac/shared';
import { app } from './firebase';

const fns = getFunctions(app, 'us-east1');

export async function reserve(
  vendor: Vendor,
  method: PaymentMethod,
  tableIds: string[],
): Promise<{ reservationId: string; code: string }> {
  const claim = httpsCallable(fns, 'claimTablesFn');
  const submit = httpsCallable(fns, 'submitReservationFn');

  const claimed = (await claim({ tableIds })).data as {
    reservationId: string;
    code: string;
  };

  await submit({
    reservationId: claimed.reservationId,
    vendor,
    paymentMethod: method,
  });

  return claimed;
}
